import { createSlice } from "@reduxjs/toolkit";
// import  storage from "redux-persist/lib/storage";
import storage from "../../constants/storage";

const initialStateOfCommonData = {
  airports: [],
  popularAirports: [],
  passengerTypes: [],
  productClasses: [],
  genderTypes: [],
  navData: {},
  addhosStory: {}
};

export const commonData = createSlice({
  name: "commonData",
  initialState: initialStateOfCommonData,
  reducers: {
    initiateCommonData: (state) => {
      storage.removeItem("persist:root");
      state = initialStateOfCommonData;
    },
    setCommonData: (state, action) => {
      if (typeof action.payload.navData !== "undefined") {
        state.navData = action.payload.navData;
      }
      if (typeof action.payload.airports !== "undefined") {
        state.airports = action.payload.airports;
      }
      if (typeof action.payload.popularAirports !== "undefined") {
        state.popularAirports = action.payload.popularAirports;
      }
      if (typeof action.payload.passengerTypes !== "undefined") {
        state.passengerTypes = action.payload.passengerTypes;
      }
      if (typeof action.payload.productClasses !== "undefined") {
        state.productClasses = action.payload.productClasses;
      }
      if (typeof action.payload.genderTypes !== "undefined") {
        state.genderTypes = action.payload.genderTypes;
      }
    }
  },
  setAddhosStory: (state, action) => {
    state.addhosStory = action.payload.addhosStory;
  }
});

export const {
  setAirports,
  setPopularAirports,
  setPassengerTypes,
  setProductClasses,
  setGenderTypes,
  initiateCommonData,
  setCommonData,
  setAddhosStory
} = commonData.actions;

export default commonData.reducer;
